import { __makeTemplateObject } from '../node_modules/tslib/tslib.es6.js';
import React from 'react';
import styled from 'styled-components';
import { Colors } from '../Colors.js';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: ", ";\n  margin-bottom: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: ", ";\n  margin-bottom: 10px;\n"])), function (props) { return (props.isMax ? Colors.Red : Colors.Grey3); });
var MaxLength = function (_a) {
    var value = _a.value, maxLength = _a.maxLength, maxLengthDisabled = _a.maxLengthDisabled;
    if (maxLengthDisabled) {
        return null;
    }
    return (React.createElement(Container, { isMax: (value === null || value === void 0 ? void 0 : value.length) === maxLength }, value === null || value === void 0 ? void 0 :
        value.length,
        "/",
        maxLength));
};
var templateObject_1;

export { MaxLength as default };
//# sourceMappingURL=MaxLength.js.map
